import React, { Component } from 'react';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';
import SelectWithLabel from '../../../../../Common/Components/SelectWithLabel';

class FechaHoraArchivo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, checkArchivosAsociados } = this.props;
        const { archivoAsociado } = data;

        let checkFecha = archivoAsociado.checkFecha;
        let checkHora = archivoAsociado.checkHora;

        let optionFormatoFecha = [], optionFormatoHora = [];

        if(archivoAsociado?.optionFormatoFecha && archivoAsociado.optionFormatoFecha.length > 0){
            optionFormatoFecha = archivoAsociado.optionFormatoFecha.map((formatoFecha, index) => {
                return (
                    <option value={formatoFecha.Id} key={"formatoFecha-option-" + index} data-codigo={formatoFecha.Id}>
                        {formatoFecha.Descripcion}
                    </option>
                );
            });
        }

        if(archivoAsociado?.optionFormatoHora && archivoAsociado.optionFormatoHora.length > 0){
            optionFormatoHora = archivoAsociado.optionFormatoHora.map((formatoHora, index) => {
                return (
                    <option value={formatoHora.Id} key={"formatoHora-option-" + index} data-codigo={formatoHora.Id}>
                        {formatoHora.Descripcion}
                    </option>
                );
            });
        }   

        return (
            <div className='row top-separator-xs'>
                <div className="contenedorCheckBox">
                    <div className="col-md-12 no-padding-left">
                        <CheckDefecto
                            nombre={"Agregar fecha al archivo"}
                            id={"checkFecha"}
                            referencia={"checkFecha"}
                            check={checkFecha}
                            selectCheckBox={(event) => checkArchivosAsociados("checkFecha", event.target.checked)}
                        />
                    </div>
                    <div className="col-md-12 no-padding-left">
                        <CheckDefecto
                            nombre={"Agregar hora al archivo"}
                            id={"checkHora"}
                            referencia={"checkHora"}
                            check={checkHora}
                            selectCheckBox={(event) => checkArchivosAsociados("checkHora", event.target.checked)}
                        />
                    </div>
                </div>
                <div className="contenedorCheckBox top-separator-xs">
                    <div className="col-md-12 no-padding-left">
                        {checkFecha &&
                            <SelectWithLabel
                                options={optionFormatoFecha}
                                seleccionarCombo={this.props.setOptionFormatoArchivo}
                                value={archivoAsociado.optionSeleccionadaFecha}
                                nombreCombo="optionSeleccionadaFecha"
                                titulo="Formato"
                                mensajeError={archivoAsociado.errorComboFecha ? "Seleccione una opción" : null}
                            />
                        }
                    </div>

                    <div className="col-md-12 no-padding-left">
                        {checkHora &&
                            <SelectWithLabel
                                options={optionFormatoHora}
                                seleccionarCombo={this.props.setOptionFormatoArchivo}
                                value={archivoAsociado.optionSeleccionadaHora}
                                nombreCombo="optionSeleccionadaHora"
                                titulo="Formato"
                                mensajeError={archivoAsociado.errorComboHora ? "Seleccione una opción" : null}
                            />
                        }
                    </div>
                </div>
            </div >
        )
    };
}

export default FechaHoraArchivo;
